import React from 'react';

import { SubHeading } from '../../Components';
import { images } from '../../constants';

const FindUs = () => (
  <div className="app__bg app__wrapper section__padding" id="contact">
  <div className="app__wrapper_info" data-aos="fade-right">
    <SubHeading title="Get in Touch" />
    <h1 className="headtext__cormorant" style={{ marginBottom: '3rem' }}>Visit Us</h1>
    <div className="app__wrapper-content">
      <p className="p__opensans">123 Grand Avenue, Central City, NY 10001</p>
      <p className="p__cormorant" style={{ color: '#DCCA87', margin: '2rem 0' }}>Hours of Operation</p>
      <p className="p__opensans">Monday to Thursday: 11:00 AM - 11:00 PM</p>
      <p className="p__opensans">Friday to Sunday: 11:00 AM - 12:00 AM</p>
    </div>
    <button type="button" className="custom__button" style={{ marginTop: '2rem' }} data-aos="zoom-in">Reach Out</button>
  </div>

  <div className="app__wrapper_img" data-aos="fade-left">
    <img src={images.findus} alt="findus_img" />
  </div>
</div>
);

export default FindUs;